import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';
import { lowHeightScreens } from '../../../common/fontElements';

export const Container = styled.div`
  display: flex;
  flex: 1 1 0;
  padding: 30px;
  align-items: center;
  flex-direction: column;
  background-color: ${colors.baseBackground};

  @media (max-height: ${lowHeightScreens}) {
    padding: 50px 30px;
  }
`;
export const InnerContainer = styled.div`
  margin-top: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const SubText = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  text-align: center;
  font-size: 11px;
  color: ${colors.darkGray1};

  @media (max-height: ${lowHeightScreens}) {
    font-size: 10px;
  }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  top: -100vh;
  left: -100vw;
  & + label {
    position: relative;
    display: flex;
    align-items: center;
    cursor: default;
    &::before {
      content: url('/images/checkboxes/circle_unchecked-2.svg');
      width: 15px;
      height: 15px;
      margin-right: 10px;
      cursor: default;
    }
    & + span {
      margin: 0 0 5px 10px;
      color: ${colors.purple1};
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  &:checked + label {
    &::before {
      content: url('/images/checkboxes/circle_checked-2.svg');
      width: 15px;
      height: 15px;
      margin-right: 10px;
      cursor: default;
    }
    & + span {
      color: #882dbf;
    }
  }
`;
export const CheckboxAndLabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ThumbsUpIcon = styled.img`
  margin: 5px;
`;
export const ThumbsUpIconLabel = styled.p`
  margin: 5px;
  color: ${colors.darkGray1};
`;
